import { createSelector } from 'reselect';

import getMember from './getMember';

export default createSelector(
  [getMember],
  (member): boolean => !!member && !member.registered,
);
